<template>
  <div class="ids-root" style="height: 100%;">
    <div class="information">
      <div class="vbox">
        <div class="loading" data-loader="circle"></div>
      </div>
      <p>{{ $t('加载中...') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iDS-Root',
  mounted() { }
}
</script>

<style lang="scss">
.ids-root {
  #container {
    margin-left: 30px;
    font-size: 12px;
    color: #c0c0c0;
    display: flex;
    flex-wrap: wrap;
    width: 700px;
    background-color: #17607d;
    padding-top: 20px;
  }

  .vbox {
    display: flex;
    flex-direction: column;
  }

  .vbox>div {
    margin-left: 2rem;
  }

  &[data-loader='circle'] {
    border: 2px solid black !important;
  }

  .information {
    position: absolute;
    top: calc((100% - 9rem) / 2);
    left: calc((100% - 5rem) / 2);

    p {
      text-align: center;
      font-size: 1.5rem;

      span {
        color: gray;
      }
    }
  }

  #loadbox {
    width: 50%;
    height: 20%;
    position: relative;
    left: 25%;
    top: 25%;
    border-radius: 5px;
    position: fixed;
    z-index: 10003;
    background: #fff;
  }

  .loadmask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10002;
    background: #000000;
    opacity: 0.5;
  }

  .loadbox {
    margin: 0 auto;
  }

  .loadicon {
    margin: 0 auto !important;
    margin-top: 20px !important;
  }

  .loadcontent {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  [data-loader] {
    margin: 8px;
  }

  [data-loader='circle'] {
    width: 25px;
    height: 25px;

    -webkit-animation: circle infinite 0.75s linear;
    -moz-animation: circle infinite 0.75s linear;
    -o-animation: circle infinite 0.75s linear;
    animation: circle infinite 0.75s linear;

    border: 2px solid #000000;
    border-top-color: transparent;
    border-radius: 100%;
  }

  @-webkit-keyframes circle {
    0% {
      -webkit-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-moz-keyframes circle {
    0% {
      -webkit-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-o-keyframes circle {
    0% {
      -webkit-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes circle {
    0% {
      -webkit-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
